import ResourceModal from 'app/components/ResourceModal';
import DefaultMomentsUploadForm from './DefaultMomentsUploadForm';

const DefaultMomentsUploadModal = props => {
  const {
    isOpen,
    onClose,
    onFormSubmit,
    job,
    center
  } = props;

  let action = 'create';
  let title = 'Upload Default Moments';
  let message = 'These moments will appear for every customer on the job';
  let unmountOnClose = true;

  const onSubmit = params => onFormSubmit(action, params);

  return (
    <ResourceModal {...{ isOpen, onClose, title, message, center, unmountOnClose }}>
      <DefaultMomentsUploadForm {...{ action, onClose, onSubmit, job }} />
    </ResourceModal>
  );
}

export default DefaultMomentsUploadModal;
